export const ButtonOptionsFormFieldProp = Object.freeze({
    Name: 'name',
    PositionRow: 'PositionRow',
    Label: 'label',
    DataType: 'dataType',
    Value: 'value',
    Options: 'options',
});